const css = `.NBd83q__divider{width:100%;height:1px;border:none;margin:0}.NBd83q__dark{background-color:#c8d2d9}.NBd83q__medium{background-color:var(--base-strokes-default)}.NBd83q__light{background-color:#f9f9f9}.NBd83q__inset{margin-left:48px}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"medium":"NBd83q__medium","dark":"NBd83q__dark","light":"NBd83q__light","inset":"NBd83q__inset","divider":"NBd83q__divider"};
